import { render, staticRenderFns } from "./RestockRequestPanel.vue?vue&type=template&id=7d45f338"
import script from "./RestockRequestPanel.vue?vue&type=script&lang=js"
export * from "./RestockRequestPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports